import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { Button } from '../Button';
import { useStyles } from './DashedButton.styles';
export var DashedButton = React.forwardRef(function (props, ref) {
    var styles = useStyles(props);
    var className = props.className, otherProps = __rest(props, ["className"]);
    return (React.createElement(Button, __assign({ variant: "text", ref: ref, className: clsx(className, styles.root) }, otherProps)));
});
export default DashedButton;
//# sourceMappingURL=DashedButton.js.map